module.exports = "/_next/static/images/konfhubPoweredby-015590f6ca5c3177893e510a7f0ed541.png";